import { formatString } from 'src/services/string-formatter'
import { CustomerCreditCheckFormFields, CustomerCreditCheckFormFieldsObject, CustomerName, CustomerNameInitialState } from 'src/typings/api-models/creditCheck'
import { getType } from 'typesafe-actions'
import actions, { CreditCheckActions } from './actions'

export interface CustomerCreditCheckState {
  displayMessage: string
  fields: CustomerCreditCheckFormFields
  igsCustomerNumber: string
  loaded: boolean
  originalName: CustomerName
  response: string
  valid: boolean
  customerInvitationGuid: string
}

export const CustomerCreditCheckInitialState = {
  displayMessage: '',
  fields: new CustomerCreditCheckFormFieldsObject(),
  igsCustomerNumber: '',
  loaded: false,
  originalName: CustomerNameInitialState,
  response: '',
  valid: false,
  customerInvitationGuid: ''
}

const initialState = CustomerCreditCheckInitialState

const reducer = (state: CustomerCreditCheckState = initialState, action: CreditCheckActions): CustomerCreditCheckState => {
  switch (action.type) {
    case getType(actions.getCustomerInformation.request):
      return {
        ...state,
        customerInvitationGuid: action.payload
      }
    case getType(actions.getCustomerInformation.success):
      const hasAddress = action.payload.address != null
      return {
        ...state,
        igsCustomerNumber: action.payload.referenceNumber,
        displayMessage: '',
        fields: Object.assign({}, new CustomerCreditCheckFormFieldsObject(), {
          addressLine1: Object.assign({}, state.fields.addressLine1, {
            valid: hasAddress && action.payload.address.addressLine1 && action.payload.address.addressLine1.length > 0,
            value: hasAddress && action.payload.address.addressLine1 ? action.payload.address.addressLine1 : ''
          }),
          addressLine2: Object.assign({}, state.fields.addressLine2, {
            valid: hasAddress && action.payload.address.addressLine2 && action.payload.address.addressLine2.length > 0,
            value: hasAddress && action.payload.address.addressLine2 ? action.payload.address.addressLine2 : ''
          }),
          city: Object.assign({}, state.fields.city, {
            valid: hasAddress && action.payload.address.city && action.payload.address.city.length > 0,
            value: hasAddress && action.payload.address.city ? action.payload.address.city : ''
          }),
          firstName: Object.assign({}, state.fields.firstName, {
            valid: true,
            value: action.payload.firstName
          }),
          lastName: Object.assign({}, state.fields.lastName, {
            valid: true,
            value: action.payload.lastName
          }),
          legalNameCorrectlyRepresented: Object.assign({}, state.fields.legalNameCorrectlyRepresented, {
            valid: true,
            value: true
          }),
          middleInitial: Object.assign({}, state.fields.middleInitial, {
            valid: true,
            value: action.payload.middleInitial
          }),
          phone: Object.assign({}, state.fields.phone, {
            valid: action.payload.phoneNumber && action.payload.phoneNumber.length > 0,
            value: action.payload.phoneNumber ? formatString(action.payload.phoneNumber, '(###) ###-####').result : ''
          }),
          state: Object.assign({}, state.fields.state, {
            valid: hasAddress && action.payload.address.state && action.payload.address.state.length > 0,
            value: hasAddress && action.payload.address.state ? action.payload.address.state : ''
          }),
          zip: Object.assign({}, state.fields.zip, {
            valid: hasAddress && action.payload.address.zipCode && action.payload.address.zipCode.length > 0,
            value: hasAddress && action.payload.address.zipCode ? action.payload.address.zipCode : ''
          })
        }),
        loaded: true,
        originalName: {
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          middleInitial: action.payload.middleInitial
        }
      }
    case getType(actions.getCustomerInformation.failure):
      return {
        ...state,
        displayMessage: 'This invitation has either already been used, or is otherwise invalid. \n Please ask your sales representative to send another.',
        igsCustomerNumber: '',
        fields: new CustomerCreditCheckFormFieldsObject(),
        customerInvitationGuid: ''
      }
    case getType(actions.postCreditCheckForm.request):
      return {
        ...state,
        loaded: false
      }
    case getType(actions.postCreditCheckForm.success):
      return {
        ...state,
        displayMessage: action.payload.message,
        fields: Object.assign({}, state.fields, {
          ssn: {
            ...state.fields.ssn,
            required: true
          }
        }),
        loaded: true,
        response: action.payload.response,
        valid: false
      }
    case getType(actions.postCreditCheckForm.failure):
      return {
        ...state,
        displayMessage: 'There was a problem submitting the form. Please try again later',
        loaded: true
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/store/creditCheck/reducer.ts